<template>
  <div class="map-view">
    <GmapMap :center="getCenter" :zoom="zoom" class="map">
      <GmapMarker
        v-for="(marker,id) in markers"
        :position="marker.position"
        :title="marker.title"
        :clickable="true"
        :draggable="false"
        :key="id"
        @click="clickMarker(marker)"
      ></GmapMarker>
    </GmapMap>
  </div>
</template>
<script>
export default {
  props: {
    mapHeight: String,
    markers: Array,
    //   { position: { lat: 35.71, lng: 139.72 }, title: "marker_1" }
    center: {
      type: Object,
      required: false,
      default: function() {
        return {};
      }
    },
    zoom: {
      type: Number,
      default: 14
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    clickMarker: function(marker) {
      //ボタンをクリックするとこのメソッドが起動する
      this.$emit("click-marker", marker); //親へイベント発火を伝える
    }
  },
  computed: {
    getCenter() {
      return (
        this.center ||
        (this.markers && this.markers.length && this.markers[0].position)
      );
    }
  }
};
</script>
<style scoped>
.map {
  max-width: 100%;
  height: 400px;
}
</style>
<style lang="scss">
</style>

